import React from "react";
import PaymentsListTable from "./payment_list_table.component";
import { Api } from "../../utils/api";
import { withRouter } from "react-router";

class PaymentItemsTable extends React.Component {
  state = {
    entityPayments: {},
    hideSummary: false,
  };

  constructor() {
    super();
    this.api = new Api();
    this.hideSummary = this.hideSummary.bind(this);
  }

  componentDidMount() {
    const easypay_reference_id = this.props.easypay_reference_id;
    this.api
      .get("/easypay_payments", {
        easypay_reference_id,
        payments_processed: "true",
        page: 1,
      })
      .then(({ data: { easypay_payments } }) => {
        this.setState({ entityPayments: easypay_payments });
      });
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  hideSummary() {
    this.setState({ hideSummary: !this.state.hideSummary });
  }

  /**
   *
   */

  render() {
    const easypay_payments = this.state.entityPayments;
    const lastPayment = this.state.entityPayments[0];

    return (
      <>
        {lastPayment && (
          <PaymentsListTable
            payments={easypay_payments}
            rowsPerPage={100}
            page={1}
            showNewInvoice={true}
          />
        )}
      </>
    );
  }
}

export default withRouter(PaymentItemsTable);
